import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { z } from "zod"

// Reference to SlotParticipantDto in swagger
export const SlotSubscriberDtoSchema = z
  .object({
    memberId: z.string(),
    userId: z.string().nullable(),
    firstname: z.string(),
    lastname: z.string(),
    username: z.string().nullable(),
    avatar: HUImageDtoSchema.nullable(),
    absent: z.boolean(),
    isBirthday: z.boolean(),
    isTrial: z.boolean().nullable(),
    isDropIn: z.boolean().nullable(),
    internalNote: z.string().nullable(),
  })
  .meta({ id: "SlotSubscriberDtoSchema" })

export type SlotSubscriberDto = z.infer<typeof SlotSubscriberDtoSchema>
